import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-carousel-stories',
    templateUrl: './block-carousel-stories.component.html',
})

export class BlockCarouselStoriesComponent extends BlockAbstractComponent implements OnInit {
    currentIndex: number = 1;

    slideConfig = {
        loop: true,
        navigation: {
            nextEl: '.stories-carousel-controls__next',
            prevEl: '.stories-carousel-controls__prev'
        },
        pagination: {
            bulletActiveClass: 'stories-carousel-controls__indicator--active',
            bulletClass: 'stories-carousel-controls__indicator',
            clickable: true,
            el: '.stories-carousel-controls__indicator-dots'
        },
        slideClass: 'stories-carousel-slider__item',
        slideActiveClass: 'stories-carousel-slider__item--active',
        wrapperClass: 'stories-carousel-slider__container',
        breakpoints: {
            1200: {
                slidesPerView: 1.65,
                spaceBetween: 30
            },
        },
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0
    }

    onIndexChange(index: number) {
        this.currentIndex = index + 1;
    }

    parseImagePath(blockImagePath: string): string {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            return 'url(https://benefits.paloaltonetworks.com' + blockImagePath + ')'
        } else {
            return 'url(' + blockImagePath + ')'
        }
    }
}
